import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import $ from 'jquery';
import 'jquery-form';
import 'jquery-validation';
import '../../assets/scripts/jquery-validation.init';
import * as helper from '../global/helper';
import swal from 'sweetalert2';
import { agentSignup, sendReferralCodeRequest, googleSignupAPI} from '../api/agentAPI';
import { setTempState } from '../../assets/scripts/login-util';
import { googleLogin } from './loginHelper';
import { EmailField, PasswordField, OrDivider, ArrowIcon } from './authFields';



const RequestCodeModal = (props) => {
  const [data, setData] = useState({});

  useEffect(() => {
      $('#requestcode-modal').modal({ backdrop: 'static' });

      $('#requestcode-modal').on('hidden.bs.modal', function () {
        $('.modal').hasClass('show') && $('body').addClass('modal-open');   
        props.onDismissModal();        
      });
  }, []);


  const handleFormInput = (key, value) => {
    setData( () => {
      return {...data, [key] : value};
    })
  }

  const requestCode = async (e) => {
    e.preventDefault();

    var form = $('#requestcode-form');
    form.validate().destroy();

    form.validate({
      rules: {
        Name: {
          required: true,
        },
        Email: {
          required: true,
        },
        ContactNo: {
          required: true,
        },
        EmployeeStrength: {
          required: true,
        }
      },
    });

    if (!form.valid()) return;

    try {
      helper.StartProcessing($('#requestCode'));
      await sendReferralCodeRequest(data);

    } catch (err) {
      swal.fire({
        icon              : 'error',
        titleText         : 'Error!',
        text              : err.message,
        buttonsStyling    : false,
        confirmButtonClass: 'btn btn-brand',
      });
      
      return helper.StopProcessing($('#requestCode'));
    }

    helper.StopProcessing($('#requestCode'));
    $('#requestcode-modal').modal('hide');
    swal.fire({
      toast               : true,
      icon                : 'success',
      titleText           : `Request Sent successfully!`,
      position            : 'bottom-end',
      showConfirmButton   : false,
      timer               : 1500,
      animation           : false,
      customClass         : {
        popup: 'margin-20',
      },
    });
  };

  return (
    <div
      className="modal fade"
      id="requestcode-modal"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true">
    
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
             Request Promo Code
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close">
            </button>
          </div>
          <div className="modal-body">
            <div className="client-container">
              <form id="requestcode-form" onSubmit={requestCode}>
                <div className="row">
                  <div className="col-12">
                    <input
                      id="Name"
                      value={data.Name}
                      name="Name"
                      placeholder="Name"
                      className="form-control margin-b10"
                      type="text"
                      onChange={({ target: { value } }) => handleFormInput('Name', helper.capitalize(value)) }/>          
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <input
                      id="Email"
                      value={data.Email}
                      name="Email"
                      placeholder="Email"
                      className="form-control margin-b10"
                      type="text"
                      onChange={({ target: { value } }) => handleFormInput( 'Email', helper.capitalize(value))}/>                          
                  </div>

                  <div className="col-3">
                    <input
                      id="ContactNo"
                      value={data.ContactNo}
                      name="ContactNo"
                      placeholder="Contact No"
                      className="form-control margin-b10"
                      type="text"
                      onChange={({ target: { value } }) => handleFormInput('ContactNo', value)}/>                          
                  </div>
                  <div className="col-3">
                    <input
                      id="EmployeeStrength"
                      value={data.EmployeeStrength}
                      name="EmployeeStrength"
                      placeholder="Employee Strength"
                      className="form-control margin-b10"
                      type="Number"
                      min="1"
                      max="100"
                      onChange={({ target: { value } }) => handleFormInput('EmployeeStrength', value)}/>                          
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary margin-0 margin-r5"
              data-dismiss="modal">   
              Close
            </button>
            <button
              id="requestCode"
              onClick={requestCode}
              type="button"
              className="btn btn-brand margin-0">   
              Request
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


const SignUp = (props) => {
  const googleErrorLogs = ['auth/popup-closed-by-user', 'auth/popup-blocked', 'auth/cancelled-popup-request'];
  const history                           = useHistory();
  const [user,          setUser]          = useState({});
  const [showCodeModal, setCodeModal]     = useState(false); 
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading,  setLoading]            = useState(false);

  useEffect(() => {
    document.title = "Sign Up For Free Trial | Insurebox.co"
    document.getElementsByTagName('meta')["description"].content = "Register today and get an insurance software free trial from Insurebox."
  })

  const userDataHandler = (key, value) => {
    setUser( d => { return {...d, [key] : value}; })
  }
  
  const submitHandler = async (event) => {
    event.preventDefault();
    const btn = $('#kt_login_signup_submit');
    const form = $('#kt-signup-form');
    form.validate().destroy();

    form.validate({
      rules: {
        email: {
          required: true,
          email: true,
        },
        password: {
          required: true,
          minlength : 6,
        },
        confirmPassword: {
          required: true,
          equalTo: '#ib-signup-password',
        },
      },
      messages: {
        confirmPassword: { equalTo: 'Passwords do not match' },
      },
    });
    if (!form.valid()) return;
      
    helper.StartProcessing(btn);
    try {
     const response =  await agentSignup(user);

     if(!response.serverTimestamp){
        //Create a Session Cookie and Push user to Setup
        setTempState(response);
        props.onLogin('created');
     }else{
        history.push({ pathname: '/verify/email', state: {Email : user.Email, serverTimestamp : response.serverTimestamp }});
     }
    } catch (err) {
      swal.fire({
        icon               : 'warning',
        text               : err.message || 'Unkown error',
        buttonsStyling     : false,
        confirmButtonClass : 'btn btn-brand'
      });
      return helper.StopProcessing(btn);
    }
  };

  const onGoogleSignup = async(e) => {
    const form = $('#kt-signup-form');
    const btn = $('#kt_login_signin_google');
    form.validate().destroy();

    form.validate({
      rules: {
        email: {
          required: false,
        },
        password: {
          required: false,
        },
        confirmPassword: {
          required: false,
        },
      },
    });

    if (!form.valid()) return; 

    setLoading(true)
    helper.StartProcessing(btn)
    try {
      const IdToken = await googleLogin();
      if(IdToken){
        const params = await googleSignupAPI({
          googleTokenId : IdToken,
        });

        if(params){
          setTempState(params);
          props.onLogin('created');
        }
      }
    } catch (err) {
      setLoading(false)
      helper.StopProcessing(btn); 
      if(googleErrorLogs.includes(err.message) ) return;
      let titleText = err.message == 'User already exist'?'Please Login' : 'Error!';
      swal.fire({
        icon              : "error",
        titleText         : titleText,
        text              : err.message,
        buttonsStyling    : false,
        confirmButtonClass: "btn btn-brand",
      });
    }
  } 

  return (
    <>
      <div className="kt-login__signup">
        <div className="ib-auth-head">
          <h3 className="ib-auth-title">Create Your Account</h3>
          <p className="ib-auth-subtitle">Join InsureBox and start managing with ease</p>
        </div>
        <form className="kt-form ib-auth-form" id='kt-signup-form' onSubmit={submitHandler} noValidate>
          <EmailField
            id="ib-signup-email"
            value={user.Email || ''}
            onChange={({ target }) => userDataHandler('Email', target.value.trim())}
          />
          <PasswordField
            id="ib-signup-password"
            name="password"
            label="Password"
            placeholder="Create a password"
            autoComplete="new-password"
            value={user.Password || ''}
            onChange={({ target }) => userDataHandler('Password', target.value.trim())}
          />
          <PasswordField
            id="ib-signup-confirm-password"
            name="confirmPassword"
            label="Confirm Password"
            placeholder="Confirm your password"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={({ target }) => setConfirmPassword(target.value.trim())}
          />

          <button
            type="submit"
            disabled={loading}
            id="kt_login_signup_submit"
            className="btn ib-auth-btn ib-auth-btn--primary ib-auth-btn--spaced"
          >
            Sign Up <ArrowIcon />
          </button>

          <OrDivider />

          <button
            type="button"
            onClick={onGoogleSignup}
            disabled={loading}
            id="kt_login_signin_google"
            className="btn ib-auth-btn ib-auth-btn--google"
          >
            {helper.googleBtn}<span>Sign Up with Google</span>
          </button>

          <p className="ib-auth-switch">
            Already have an account?{' '}
            <Link to="/signin" className="ib-auth-link">Sign In</Link>
          </p>
          <p className="ib-auth-terms">
            By continuing you agree to our{' '}
            <a href="https://insurebox.co/terms-condition" className="ib-auth-link" target="_blank" rel="noopener noreferrer">
              terms and conditions
            </a>
          </p>
        </form>
      </div>
      {showCodeModal && (
        <RequestCodeModal 
          onDismissModal={() => setCodeModal(false)}
        />
      )}
    </>
  );
};

export default SignUp;
